import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
import { routerReducer, StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { UploadModule } from "@progress/kendo-angular-upload";
import "hammerjs";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../environments/environment";
import { AdminModule } from "./admin/admin.module";
import { AppComponent } from "./app.component";
import { AuthorizationModule } from "./authorization/authorization.module";
import { AbstractAuthorizationService } from "./authorization/services/abstractAuthorization.service";
import { CirculationsModule } from "./circulation/circulations.module";
import { CircCommonModule } from "./common";
import { I18nStepStatusPipe } from "./i18n/pipes";
import { I18nService } from "./i18n/services";
import { i18nEffects } from "./i18n/state/i18n.effects";
import { LoggerModule } from "./logger/logger.module";
import { MyTasksModule } from "./myTasks/myTasks.module";
import { NotificationModule } from "./notifications/notification.module";
import { ShellModule } from "./shell/shell.module";
import { AppEffects } from "./state/app.effects";
import { StepsModule } from "./step/steps.module";
import { SubstituteModule } from "./substitute/substitute.module";
import { TemplatesModule } from "./templates/templates.module";
import { UserModule } from "./user/user.module";
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from "@azure/msal-angular";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";

//CommonModule, // https://stackoverflow.com/questions/39625321/the-pipe-async-could-not-be-found
@NgModule({
    declarations: [AppComponent], //Needed for charts - no better way found :(
    bootstrap: [AppComponent], imports: [AuthorizationModule,
        CommonModule,
        CircCommonModule,
        SubstituteModule,
        StepsModule,
        MyTasksModule,
        CirculationsModule,
        AdminModule,
        TemplatesModule,
        BrowserModule,
        BrowserAnimationsModule,
        UploadModule,
        LoggerModule.forRoot({
            enableDebug: !environment.production,
            useInterceptor: true
        }),
        StoreModule.forRoot({
            router: routerReducer
        }, {}),
        EffectsModule.forRoot([i18nEffects, AppEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true
        }),
        NotificationModule,
        UserModule,
        ShellModule,
        // Connects RouterModule with StoreModule, uses MinimalRouterStateSerializer by default
        StoreRouterConnectingModule.forRoot()],
    providers: [
        {
            provide: AbstractAuthorizationService,
            useClass: environment.services.authorization
        },
        { provide: ICON_SETTINGS, useValue: { type: 'font' } },
        I18nStepStatusPipe,
        CookieService,
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ]
})
export class AppModule { }
